<template>
  <basic-container>
    <el-tabs v-model="activeName" @tab-click="handleTabs">
      <el-tab-pane label="优惠券" name="1">
        <CouponTables />
      </el-tab-pane>
      <el-tab-pane label="现金红包" name="2">
        <CashTables />
      </el-tab-pane>
    </el-tabs>
  </basic-container>
</template>

<script>
  import CouponTables from './components/winning-record-coupon.vue'
  import CashTables from './components/winning-record-cash.vue'
  // import dayjs from 'dayjs'

  export default {
    name: 'winningRecord',
    components: {
      CouponTables,
      CashTables
    },
    data() {
      return {
        activeName: '1'
      }
    },
    created() {},
    mounted() {},
    methods: {
      handleTabs(e) {
        this.activeName = e.name
      }
    }
  }
</script>

<style lang="scss" scoped></style>
